export default {
  nav: {
    brand: 'Imagenx',
    dashboard: 'Dashboard',
    myImages: 'My Images',
    history: 'History',
    account: 'My Account',
    support: 'Support',
    admin: 'Admin',
    logout: 'Logout',
    credits: '{count} credit | {count} credits',
    creditsTitle: 'Your credit balance — click to top up',
    creditsLow: 'Low balance: not enough credits left for one image. Click to top up.'
  },
  common: {
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    rename: 'Rename',
    loading: 'Loading...',
    close: 'Close',
    backToHome: 'Back to home',
    status: {
      pending: 'Pending',
      processing: 'Processing',
      completed: 'Completed',
      failed: 'Failed'
    }
  },
  dashboard: {
    title: 'Generate Images',
    mainPromptLabel: 'Main prompt (style, mood, format)',
    loadPreset: 'Load preset...',
    savePreset: 'Save as preset',
    deletePreset: 'Delete preset',
    mainPromptPlaceholder: 'e.g. Cinematic photography, dramatic lighting, 8k, ultra detailed...',
    aspectRatio: 'Aspect ratio',
    aspectSquare: '1:1 (Square)',
    aspectLandscape: '16:9 (Landscape)',
    aspectPortrait: '9:16 (Portrait)',
    type: 'Type',
    none: 'None',
    typePhotography: 'Photography',
    typeIllustration: 'Illustration',
    type3dRender: '3D Render',
    typeDigitalArt: 'Digital Art',
    typeOilPainting: 'Oil Painting',
    typeWatercolor: 'Watercolor',
    typePencilSketch: 'Pencil Sketch',
    typePixelArt: 'Pixel Art',
    realism: 'Realism',
    realismPhotorealistic: 'Photorealistic',
    realismHyperrealistic: 'Hyperrealistic',
    realismStylized: 'Stylized',
    realismAbstract: 'Abstract',
    realismCartoon: 'Cartoon',
    lighting: 'Lighting',
    lightingNatural: 'Natural light',
    lightingStudio: 'Studio lighting',
    lightingDramatic: 'Dramatic lighting',
    lightingGoldenHour: 'Golden hour',
    lightingNeon: 'Neon glow',
    lightingSoft: 'Soft diffused',
    lightingBacklit: 'Backlit',
    lightingLowKey: 'Low-key',
    mood: 'Mood',
    moodCinematic: 'Cinematic',
    moodDreamy: 'Dreamy',
    moodDarkMoody: 'Dark & moody',
    moodVibrant: 'Vibrant',
    moodMinimalist: 'Minimalist',
    moodVintage: 'Vintage',
    moodFuturistic: 'Futuristic',
    coherence: 'Consistency',
    coherenceNone: 'None',
    coherenceStyle: 'Same style',
    coherenceVariation: 'Same scene',
    coherenceHint: {
      none: 'Only the main prompt ties the images together',
      style: 'The first image guides the style, every scene stays its own',
      variation: 'The other images reuse the first one and only alter what you ask for'
    },
    coherenceNeedsTwo: 'Requires at least 2 images',
    referenceBadge: 'Reference',
    savePresetTitle: 'Save Preset',
    presetNamePlaceholder: 'Preset name...',
    imagePlaceholder: 'Image {n} - Describe this specific image...',
    remove: 'Remove',
    addImage: '+ Add image',
    generating: 'Generating...',
    generateMany: 'Generate {count} image | Generate {count} images',
    dismiss: 'Dismiss',
    results: 'Results',
    downloading: 'Downloading...',
    downloadSelected: 'Download selected',
    downloadSelectedCount: 'Download {count} selected',
    saving: 'Saving...',
    saveSelected: 'Save selected',
    saveSelectedCount: 'Save {count} selected',
    queued: 'Queued',
    failed: 'Failed',
    saveToFolder: 'Save to folder',
    newFolderPlaceholder: 'New folder name',
    newFolder: 'New folder',
    imageCount: '{count} image | {count} images'
  },
  history: {
    title: 'Generation History',
    empty: 'No generations yet.',
    createFirst: 'Create your first batch',
    imagesCount: '{count} image | {count} images',
    noImage: 'No image'
  },
  myImages: {
    title: 'My Images',
    rename: 'Rename',
    deleteFolder: 'Delete folder',
    empty: 'No saved images yet.',
    generateFirst: 'Generate some images first',
    folderEmpty: 'This folder is empty.',
    imagesCount: '{count} image | {count} images',
    downloadImage: 'Download image',
    deleteImage: 'Delete image',
    clickToEdit: 'Click to edit',
    renameFolderTitle: 'Rename folder',
    confirmDeleteFolder: 'Delete this folder and all its images?'
  },
  auth: {
    signInSubtitle: 'Sign in to your account',
    createSubtitle: 'Create your account',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm password',
    minChars: 'Min 6 characters',
    signingIn: 'Signing in...',
    signIn: 'Sign in',
    creatingAccount: 'Creating account...',
    createAccount: 'Create account',
    noAccount: 'Don\'t have an account?',
    signUp: 'Sign up',
    hasAccount: 'Already have an account?',
    forgotPassword: 'Forgot your password?',
    forgotPasswordTitle: 'Forgot password',
    forgotPasswordSubtitle: 'Get a reset link by email',
    sendResetLink: 'Send reset link',
    sending: 'Sending...',
    forgotEmailSent: 'If that email exists, reset instructions have been sent.',
    resetPasswordTitle: 'New password',
    resetPasswordSubtitle: 'Choose a new password',
    newPassword: 'New password',
    confirmNewPassword: 'Confirm new password',
    resetPasswordButton: 'Reset password',
    resetting: 'Resetting...',
    resetSuccess: 'Password updated. You can now sign in.',
    backToLogin: 'Back to sign in',
    checkEmailTitle: 'Check your email',
    checkEmailBody: 'A confirmation email was sent to {email}. Click the link inside to activate your account and your free credits.',
    checkEmailResent: 'This account already existed but was never confirmed: we simply sent the email again. Sign in with the password you chose on your first attempt (or use "forgot password").',
    confirmingEmail: 'Confirming...',
    confirmSuccess: 'Email confirmed! You can now sign in.',
    confirmError: 'This confirmation link is invalid or has expired.',
    resendConfirmation: 'Resend confirmation email',
    resendSuccess: 'If that account exists and is unconfirmed, a new email has been sent.',
    unconfirmedError: 'Please confirm your email before signing in.'
  },
  landing: {
    hero: {
      badge: 'Batch AI image generation',
      title: 'One main prompt. Several coherent images.',
      subtitle: 'ImageNX generates several AI images at once from a shared main prompt plus a prompt of its own for each image. Fast, coherent, with dropdowns instead of jargon, and pay-as-you-go without a subscription.',
      ctaPrimary: 'Create a free account',
      ctaSecondary: 'Sign in',
      creditsNote: '80 free credits on signup, no credit card required.'
    },
    howItWorks: {
      title: 'How it works',
      subtitle: 'The same mechanism as the generation form: one main prompt, one prompt per image.',
      step1Title: '1. One main prompt',
      step1Body: 'Describe the style, mood and lighting shared by every image — or pick them from simple dropdowns, no need to know the technical jargon.',
      step2Title: '2. One prompt per image',
      step2Body: 'Add as many images as you need, each with its own subject.',
      step3Title: '3. One coherent batch',
      step3Body: 'ImageNX generates every image in parallel, with a consistent visual style.'
    },
    features: {
      title: 'Why ImageNX',
      speedTitle: 'Fast',
      speedBody: 'Generate several images in a single batch instead of running them one by one.',
      coherenceTitle: 'Coherent',
      coherenceBody: 'The shared main prompt keeps a consistent style across the whole batch.',
      simpleTitle: 'No jargon',
      simpleBody: 'Dropdowns for format, lighting, graphic style — no need to know "ambient light" or "3D cel shading".',
      payAsYouGoTitle: 'Pay as you go',
      payAsYouGoBody: 'No subscription: top up credits and only use them when you generate images.',
      agentsTitle: 'Connect your AI agents',
      agentsBody: 'A token-authenticated API to plug in Claude Code, Claude Desktop, or your own scripts, with a dedicated skill provided to get started in minutes.'
    },
    gallery: {
      title: 'One main prompt, several images',
      subtitle: 'Two batches generated in one go with the "Same style" mode: the first image is the visual reference, the next ones share its world without copying its scene.',
      setALabel: 'Cinematic photography',
      setBLabel: 'Vintage poster',
      referenceBadge: 'Reference'
    },
    pricing: {
      title: 'Pay as you go',
      body: 'No subscription, no commitment. Top up credits and use them as you generate images.',
      trialTitle: '80 free credits',
      trialBody: 'Try ImageNX for free as soon as you create your account, no credit card required — enough for about 10 images.'
    },
    footer: {
      tagline: 'Coherent, effortless batch AI image generation.',
      loginLink: 'Sign in',
      registerLink: 'Create an account',
      copyright: '© {year} ImageNX',
      legalMentions: 'Legal notice',
      legalPrivacy: 'Privacy',
      legalTerms: 'Terms',
      builtBy: 'Built by'
    }
  },
  account: {
    title: 'My Account',
    profile: {
      title: 'Profile',
      nameLabel: 'Name',
      emailLabel: 'Email',
      currentPasswordLabel: 'Current password',
      newPasswordLabel: 'New password',
      newPasswordPlaceholder: 'Leave blank to keep unchanged',
      passwordConfirmationLabel: 'Confirm new password',
      saveSecurity: 'Update',
      securityUpdated: 'Account details updated.'
    },
    credits: {
      title: 'Credits',
      topupTitle: 'Top up credits',
      creditsCount: '{count} credit | {count} credits'
    },
    subscription: {
      title: 'Subscription',
      pitch: 'Subscribe for €5/month and get 600 credits every month, no commitment.',
      subscribeButton: 'Subscribe — €5/month for 600 credits',
      manageButton: 'Manage subscription',
      billingHistory: 'View billing history',
      renewsOn: 'renews on {date}',
      cancelingOn: 'ends on {date}',
      status: {
        active: 'Active subscription',
        trialing: 'Trial in progress',
        past_due: 'Payment past due',
        canceled: 'Subscription canceled'
      }
    },
    history: {
      title: 'Credit history',
      empty: 'No activity yet.',
      balance: 'balance: {balance}',
      reasons: {
        trialGrant: 'Free trial credits',
        generationDebit: 'Image generation',
        generationRefund: 'Refund (generation failed)',
        topupPurchase: 'Credit top-up',
        subscriptionGrant: 'Subscription credits',
        adminAdjustment: 'Manual adjustment'
      }
    },
    checkout: {
      successMessage: 'Payment received, updating your balance...',
      cancelMessage: 'Checkout canceled.'
    }
  },
  creditsModal: {
    title: 'Top up your credits',
    balance: 'Current balance: {count} credit | Current balance: {count} credits',
    remainingImages: 'enough for about {count} image | enough for about {count} images',
    topupTitle: 'One-off top-up, no commitment',
    creditsCount: '{count} credit | {count} credits',
    imagesApprox: '≈ {count} image | ≈ {count} images',
    costNote: 'Each generated image costs {cost} credits. Your credits never expire.',
    subscription: {
      title: 'Monthly plan — €5/month',
      pitch: '{credits} credits added every month, about {images} images. Cancel anytime.',
      badge: '+20% credits',
      cta: 'Subscribe — €5/month',
      manageCta: 'Manage my subscription'
    },
    accountLink: 'See my account details and credit history'
  },
  notFound: {
    message: 'Page not found'
  },
  support: {
    title: 'Contact support',
    subtitle: 'Pick a topic, describe your request, we\'ll get back to you quickly.',
    categoryTechnical: 'Technical support',
    categoryBilling: 'Billing & Subscription',
    categoryIdea: 'Suggestion box',
    subjectLabel: 'Subject',
    messageLabel: 'Message',
    submit: 'Send',
    sending: 'Sending...',
    submitError: 'Something went wrong, please try again.',
    successMessage: 'Your message has been sent, we\'ll get back to you shortly.',
    newTicket: 'Send another message'
  },
  admin: {
    title: 'Administration',
    tabStats: 'Statistics',
    tabUsers: 'Users',
    tabSupport: 'Support',
    categoryLabels: {
      technical: 'Technical support',
      billing: 'Billing & Subscription',
      idea: 'Suggestion box'
    },
    stats: {
      freeUsers: 'Free users',
      paidUsers: 'Paid users',
      totalLogins: 'Total logins',
      recentLogins: 'Logins (last 7 days)',
      totalImages: 'Images generated',
      avgPerBatch: 'Avg images / generation',
      avgPerUser: 'Avg images / user',
      avgSavedPerFolder: 'Avg saved images / folder',
      topActive: 'Most active users'
    },
    users: {
      addButton: 'Add a user',
      editButton: 'Edit',
      searchPlaceholder: 'Search by email or name...',
      email: 'Email',
      name: 'Name',
      confirmed: 'Confirmed',
      confirmedYes: 'Confirmed',
      confirmedNo: 'Unconfirmed',
      admin: 'Admin',
      credits: 'Credits',
      signIns: 'Logins',
      subscription: 'Subscription',
      prevPage: 'Previous',
      nextPage: 'Next',
      saveError: 'Something went wrong.'
    },
    support: {
      allStatuses: 'All',
      notesPlaceholder: 'Internal notes...',
      empty: 'No tickets yet.'
    },
    ticketStatus: {
      open: 'Open',
      in_progress: 'In progress',
      resolved: 'Resolved',
      closed: 'Closed'
    }
  }
}
